export default __webpack_public_path__ + "static/media/1764.f851d905.png";